import React from 'react';
import { Shield, ShieldCheck } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { Helmet } from 'react-helmet-async';

function Login() {
  const { loginWithRspamd, isLoading, error } = useAuthStore();

  return (
    <>
      <Helmet><title>Login - Rspamd Email Scanner</title></Helmet>
      <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white/95 backdrop-blur rounded-2xl shadow-2xl p-8 text-center">
            <Shield className="w-16 h-16 text-blue-600 mx-auto mb-4" />
            <h1 className="text-3xl font-bold mb-1">Rspamd Agent</h1>
            <h2 className="text-lg text-gray-500 mb-2">Rspamd Email Scanner</h2>
            <p className="text-gray-500 text-sm mb-6">Scan your newsletters with Rspamd and SpamAssassin before sending them to clients</p>

            {error && (
              <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-3 rounded text-sm mb-4 text-left">{error}</div>
            )}

            <div className="text-left mb-6">
              <h3 className="text-center font-semibold mb-3">Features</h3>
              <ul className="space-y-1.5 text-sm text-gray-600">
                {['Advanced spam detection with Rspamd & SpamAssassin', 'Automatic scan email address (no setup required)', 'Real-time scanning results and recommendations', 'Secure OAuth2 authentication', 'File upload support (.eml, .msg, .html)', 'Comprehensive scan history and analytics'].map((f, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" />{f}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-3">
              <button onClick={() => loginWithRspamd()} disabled={isLoading}
                className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-gradient-to-r from-pink-500 to-pink-400 text-white rounded-xl font-semibold text-lg hover:from-pink-600 hover:to-pink-500 transition disabled:opacity-50">
                {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <ShieldCheck className="w-5 h-5" />}
                {isLoading ? 'Connecting...' : 'Login with Rspamd.com'}
              </button>

            </div>

            <p className="text-xs text-gray-400 mt-4">Secure OAuth2 authentication &bull; Your credentials are never stored</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
